import {
  Button,
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Typography,
} from "@suraasa/placebo-ui"
import React from "react"

type Props = {
  penalties: {
    reason: string
    percentage: number
  }[]
  children: React.ReactNode
}

const PenaltyDetails = (props: Props) => {
  return (
    <Dialog>
      <DialogTrigger>{props.children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Score Deductions</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <Typography className="text-muted">
            After a careful evaluation, the following deductions were made due
            to issues identified in your submission:
          </Typography>

          <ul className="mt-2 divide-y divide-onSurface-300 rounded-lg border border-onSurface-300 bg-onSurface-50">
            {props.penalties.map((penalty, index) => (
              <li
                key={index}
                className="flex items-center justify-between gap-2 p-2"
              >
                <Typography>{penalty.reason}</Typography>
                <Typography className="text-critical-500" variant="strong">
                  - {penalty.percentage}%
                </Typography>
              </li>
            ))}
          </ul>
        </DialogBody>
        <DialogFooter>
          <DialogClose>
            <Button color="black">I understand</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default PenaltyDetails
